import React, { useEffect, useState } from 'react'
import { Ionicons, Feather } from '@expo/vector-icons'
import {
    View,
    Image,
    TouchableOpacity,
    Text,
    StatusBar,
    ActivityIndicator,
    Platform,
} from 'react-native'
import { useNavigation, useRoute } from '../../hooks/useWebNavigation'
import {
    getConection,
    getData,
    THEME_COLOR_ALERT,
    useButtonDownloadContext,
    useTheme,
} from '../appBar/context/HeaderContext'
import theme from '../../../theme'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { Notifications } from '../notifications/Notifications'
import { useNotificationStore } from '../../redux/zustand/notificationStore'
import { SearchView } from '../appBar/SearchView'
import {
    downloadPdf,
    eventEmitter,
    isEntornoTesting,
} from '../../utils/functions.utils'
import { LinearGradient } from 'expo-linear-gradient'
import styles from './WebHeaderStyles'
import { AppBarTheme, AppGradientTheme } from '../../../themeConstants'
import { getLocation } from '../appBar/context/LocationContext'
import mediaSingleton from '../../utils/mediaSingleton'
import { UserServices } from '../../../database/user.database'
import Constants from 'expo-constants'
import { useStatusBarColorStore } from '../../redux/zustand/statusBarColorStore'
import { useDataPendingSendStore } from '../../redux/zustand/dataPendingSendStore'
import { getLanguageFile } from '../../translations/i18n'
import { getAlert } from '../appBar/context/AlertsContext'
import { useLiveProgressAlert } from '../../hooks/useLiveProgressAlert'
import { useRightSidebar } from './context/RightSidebarContext'

const languageFile = getLanguageFile()

const WebHeader = ({ onToggleSidebar, sidebarOpen, style }) => {
    const expoConfig = Constants.expoConfig || {}

    const themeContext = useTheme()
    const { backgroundColor } = themeContext || {}
    const { setAlert } = getAlert()
    const { linkDownload } = useButtonDownloadContext()
    const { generateAlertText } = useLiveProgressAlert()
    const { openRightSidebar } = useRightSidebar()

    const { without_seeing } = useNotificationStore()

    // Safe navigation hooks - only use if inside navigator
    let navigation, route, routeName
    try {
        navigation = useNavigation()
        route = useRoute()
        routeName = route?.name || 'Main'
    } catch (error) {
        // Not inside navigator context
        navigation = null
        route = null
        routeName = 'Main'
    }

    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const { isConnected, hasInternet } = getConection()
    const snapPoints = ['80%']
    const [secondaryStyle, setSecondaryStyle] = useState(false)
    const { footerRoute, customBack } = getData()
    const { userLat, userLng, locationLoaded } = getLocation()
    const [buttonsNav, setButtons] = useState([])
    const setStatusBarColor = useStatusBarColorStore(
        (store) => store.setStatusBarColor,
    )
    const havePendingData = useDataPendingSendStore((store) => store.havePendingData)
    const setProgressTotalModal = useDataPendingSendStore(
        (store) => store.setProgressTotalModal,
    )
    const progressTotalModal = useDataPendingSendStore(
        (store) => store.progressTotalModal,
    )

    const ROUTE_STYLES = {
        BenefitsHome: { secondary: true },
        Trivia: { secondary: true },
        TriviaGame: { secondary: true },
        Schedule: { secondary: true },
        StoreDetail: { secondary: true },
        ScheduleDistributor: { secondary: true },
        Ranking: { secondary: true },
        Profile: { secondary: false },
        Survey: { hideNav: true },
        Gamification: { hideNav: true },
        TriviaGame: { hideNav: true },
    }

    const handle_notification = () => {
        if (Platform.OS === 'web') {
            console.log('[WebHeader] Opening notifications sidebar')
            openRightSidebar('notifications')
        } else {
            openBottomSheet(
                <Notifications closeSearch={() => closeBottomSheet(true)} />,
                snapPoints,
            )
        }
    }

    const handle_configuration = () => {
        if (Platform.OS === 'web') {
            console.log('[WebHeader] Opening configuration sidebar')
            openRightSidebar('configuration')
        } else {
            // TODO: Implement configuration for mobile
            console.log('[WebHeader] Configuration not implemented for mobile')
        }
    }

    const searchInTheApp = async () => {
        openBottomSheet(
            <SearchView closeSearch={() => closeBottomSheet(true)} />,
            snapPoints,
        )
    }

    const goProfile = () => {
        navigation.navigate('Profile')
    }

    const goDatabase = () => {
        navigation.navigate('DatabaseScreen')
    }

    const get_info = async () => {
        try {
            let pendings = await UserServices.get_pendings_conections()
            console.log('pendings:', pendings)
            navigation.navigate('FormsAnswersScreen')
        } catch (error) {
            console.log('🚀 ~ constget_info= ~ error:', error)
        }
    }

    const handleDownloadLink = async () => {
        try {
            if (Platform.OS === 'web') {
                const url = linkDownload
                if (!url) return
                const getFileName = (inputUrl) => {
                    try {
                        const cleanUrl = inputUrl.split('?')[0]
                        const name = decodeURIComponent(
                            cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1),
                        )
                        return name || 'archivo'
                    } catch (e) {
                        return 'archivo'
                    }
                }
                const fileName = getFileName(url)
                try {
                    const res = await fetch(url)
                    const blob = await res.blob()
                    const blobUrl = URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = blobUrl
                    a.download = fileName
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    try {
                        window.open(blobUrl, '_blank', 'noopener')
                    } catch {}
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
                } catch (err) {
                    console.error(
                        '[WebHeader] fetch blob failed, fallback to direct open',
                        err,
                    )
                    window.open(url, '_blank', 'noopener,noreferrer')
                }
                return
            }
        } catch (err) {
            console.error(
                '[WebHeader] Descarga web falló, abriendo en nueva pestaña',
                err,
            )
            try {
                window.open(linkDownload, '_blank', 'noopener,noreferrer')
            } catch {}
            return
        }
        downloadPdf(linkDownload)
    }

    const [showNav, setShowNav] = useState(true)

    useEffect(() => {
        if (!footerRoute) {
            return
        }
        // setSecondaryStyle(findSecondaryStyle())
        handleButtonsUpdate()
    }, [footerRoute])

    const findSecondaryStyle = () => {
        return ROUTE_STYLES[footerRoute]?.secondary && routeName !== 'Profile'
    }

    const whereToHideNav =
        ROUTE_STYLES[routeName]?.hideNav || footerRoute === 'Gamification'

    useEffect(() => {
        try {
            if (whereToHideNav) {
                setShowNav(false)
                setStatusBarColor('light-content')
            } else {
                setShowNav(true)
                setStatusBarColor('dark-content')
            }
            handleButtonsUpdate()
            mediaSingleton.pauseAllAudios()
        } catch (error) {
            console.log('🚀 ~ useEffect webHeader ~ error:', error)
            console.error(error)
        }
    }, [route, customBack])

    const [downloadLoading, setDownloadLoading] = useState(false)

    useEffect(() => {
        const onStart = () => setDownloadLoading(true)
        const onEnd = () => setDownloadLoading(false)

        eventEmitter.on('start', onStart)
        eventEmitter.on('end', onEnd)

        eventEmitter.on('buttonsUpdated', handleButtonsUpdate)

        return () => {
            eventEmitter.removeListener('start', onStart)
            eventEmitter.removeListener('end', onEnd)
            eventEmitter.removeListener('buttonsUpdated', handleButtonsUpdate)
        }
    }, [])

    const iconColor = secondaryStyle ? 'white' : undefined
    const menuColor = () => {
        if (sidebarOpen) {
            return !secondaryStyle ? 'black' : 'white'
        } else {
            return !secondaryStyle
                ? theme.colors.colorPrimary
                : theme.colors.colorSecondary
        }
    }
    const handleButtonsUpdate = async () => {
        try {
            const res_get_footer_app = await UserServices.getNavApp()
            if (res_get_footer_app && res_get_footer_app.length > 0) {
                setButtons(res_get_footer_app)
            }
        } catch (error) {
            console.log('error => ', error)
        }
    }

    const renderTab = (button) => {
        return (
            <TouchableOpacity
                key={button._id}
                onPress={() => navigation.navigate(button.label)}
                activeOpacity={1}
                style={styles.appBarIcons}
            >
                <Feather
                    name='calendar'
                    size={24}
                    color={
                        routeName == button.label
                            ? theme.colors.colorPrimary
                            : !secondaryStyle
                              ? iconColor
                              : 'white'
                    }
                />
            </TouchableOpacity>
        )
    }

    const getProgressTotal = async () => {
        let tablesPending = await UserServices.get_pendings_conections()

        if (
            !tablesPending ||
            !tablesPending?.results ||
            Object.values(tablesPending.results).length == 0
        ) {
            return 0
        }

        const cantPending = Object.values(tablesPending.results).reduce(
            (acc, value) => {
                if (typeof value === 'number' && value > 0) {
                    acc += value
                }
                return acc
            },
            0,
        )

        return cantPending || 0
    }

    const handleIconPendingData = async () => {
        if (!isConnected || !hasInternet) {
            const message =
                'No tenés conexión. Los formularios y visitas se enviarán automáticamente cuando estés nuevamente en línea.'
            setAlert(
                message,
                'white',
                'wifi-off',
                THEME_COLOR_ALERT.ERROR,
                true,
                false,
                'Feather',
                24,
            )
            return
        }

        if (progressTotalModal === 0) {
            const totalPendingsToSend = await getProgressTotal()
            setProgressTotalModal(totalPendingsToSend)
        }

        const initialText = generateAlertText()
        setAlert(
            initialText,
            'white',
            'warning-outline',
            'rgba(0, 0, 0, 0.8)',
            true,
            true,
            'Ionicons',
            28,
        )
    }

    const isEntornoTest = isEntornoTesting()
    const MainGradientColors = [
        AppGradientTheme.mainGradientStart,
        AppGradientTheme.mainGradientEnd,
    ]
    const SecondaryGradientColors = [
        AppGradientTheme.secondaryGradientStart,
        AppGradientTheme.secondaryGradientEnd,
    ]

    return (
        showNav && (
            <LinearGradient
                colors={
                    !secondaryStyle ? MainGradientColors : SecondaryGradientColors
                }
                start={{ x: 0, y: 0.5 }}
                end={{ x: 1, y: 0.5 }}
                style={[style, styles.headerContainer]}
            >
                <View
                    style={
                        !secondaryStyle
                            ? styles.appBarParent
                            : styles.appBarParentBenefits
                    }
                >
                    <LinearGradient
                        style={{ ...styles.appBar }}
                        colors={
                            !secondaryStyle
                                ? MainGradientColors
                                : SecondaryGradientColors
                        }
                        start={{ x: 0, y: 0.5 }}
                        end={{ x: 1, y: 0.5 }}
                    >
                        <View style={styles.appBarLeft}>
                            {/* Botón de menú hamburger - solo en web */}
                            {Platform.OS === 'web' && onToggleSidebar && (
                                <TouchableOpacity
                                    style={styles.menuButton}
                                    onPress={onToggleSidebar}
                                >
                                    <Ionicons
                                        name={'menu-outline'}
                                        size={24}
                                        color={menuColor()}
                                    />
                                </TouchableOpacity>
                            )}
                            {isEntornoTest ? (
                                <TouchableOpacity onPress={() => get_info()}>
                                    <Image
                                        style={styles.appBarAvatar}
                                        source={AppBarTheme.navImage}
                                        tintColor={iconColor}
                                        resizeMode='contain'
                                    />
                                </TouchableOpacity>
                            ) : (
                                <Image
                                    style={styles.appBarAvatar}
                                    source={AppBarTheme.navImage}
                                    tintColor={iconColor}
                                    resizeMode='contain'
                                />
                            )}

                            {(!isConnected || !hasInternet) && (
                                <Image
                                    style={styles.wifi}
                                    source={require('../../../assets/no_wifi.png')}
                                    tintColor={
                                        !secondaryStyle
                                            ? theme.colors.error
                                            : 'white'
                                    }
                                />
                            )}

                            {locationLoaded === true &&
                                (userLat == null || userLat == 0) &&
                                (userLng == null || userLng == 0) && (
                                    <Image
                                        style={styles.wifi}
                                        source={require('../../../assets/noLocation.png')}
                                        tintColor={
                                            !secondaryStyle
                                                ? theme.colors.error
                                                : 'white'
                                        }
                                    />
                                )}
                        </View>

                        {routeName !== 'WebView' && (
                            <View style={styles.appBarRight}>
                                {/* <Text style={{ color: iconColor }}>
                                    {footerRoute}
                                </Text> */}

                                {havePendingData && (
                                    <TouchableOpacity
                                        onPress={() => handleIconPendingData()}
                                        activeOpacity={0.6}
                                        style={styles.appBarIcons}
                                    >
                                        <Feather
                                            name={'refresh-ccw'}
                                            size={24}
                                            color={
                                                !secondaryStyle
                                                    ? theme.colors.error
                                                    : 'white'
                                            }
                                        />
                                    </TouchableOpacity>
                                )}

                                {/* <TouchableOpacity onPress={() => searchInTheApp()} activeOpacity={0.6} style={styles.appBarIcons}>
                                    <Feather name='search' size={24} color={iconColor} />
                                </TouchableOpacity> */}

                                {buttonsNav?.length > 0 &&
                                    buttonsNav.map((tabButton) =>
                                        renderTab(tabButton),
                                    )}

                                <TouchableOpacity
                                    onPress={() => handle_configuration()}
                                    activeOpacity={0.6}
                                    style={styles.appBarIcons}
                                >
                                    <Feather
                                        name='settings'
                                        size={24}
                                        color={!secondaryStyle ? iconColor : 'white'}
                                    />
                                </TouchableOpacity>

                                <TouchableOpacity
                                    onPress={() => handle_notification()}
                                    activeOpacity={0.6}
                                    style={styles.appBarIcons}
                                >
                                    {without_seeing ? (
                                        <Image
                                            source={
                                                !secondaryStyle
                                                    ? require('../../../assets/bellActive.png')
                                                    : require('../../../assets/bellActiveWhite.png')
                                            }
                                            style={styles.bell}
                                        />
                                    ) : (
                                        <Feather
                                            name='bell'
                                            size={24}
                                            color={iconColor}
                                        />
                                    )}
                                </TouchableOpacity>
                            </View>
                        )}

                        {routeName === 'WebView' &&
                            expoConfig.slug != 'jti-connect' && (
                                <>
                                    {downloadLoading ? (
                                        <ActivityIndicator
                                            color={theme.colors.colorPrimary}
                                            size={24}
                                        />
                                    ) : (
                                        <TouchableOpacity
                                            onPress={() => handleDownloadLink()}
                                        >
                                            <Feather
                                                name='download'
                                                size={24}
                                                color={iconColor}
                                            />
                                        </TouchableOpacity>
                                    )}
                                </>
                            )}
                    </LinearGradient>
                </View>
            </LinearGradient>
        )
    )
}

export default WebHeader
